import React from 'react';
import PropTypes from 'prop-types';

import * as buttonStyles from '../styles/styles.module.scss';

const SubmitButton = ({ text, handler, variant, classes }) => {
  const onKeyPress = event => {
    if (event.key === 'Enter') {
      handler();
    }
  };

  return (
    <div className={`${buttonStyles[variant]} ${classes}`} onKeyPress={onKeyPress} onClick={handler} tabIndex="0" role="button">
      {text}
    </div>
  );
};

SubmitButton.defaultProps = {
  text: 'submit',
  handler: () => {},
  variant: 'submit',
  classes: ''
};

SubmitButton.propTypes = {
  text: PropTypes.string,
  handler: PropTypes.func,
  variant: PropTypes.string,
  classes: PropTypes.string
};

export default SubmitButton;
